<template lang="pug">
v-main
  v-container
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Edit Admin Business Unit
      v-divider
      v-card-text
        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(color="black") Name
          v-col(cols="5")
            v-text-field(
              v-model="users.full_name",
              label="Name",
              :rules="[rules.required]",
              @keypress="isLetter($event)"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") Email
            small(style="color: #F08703;" class="ml-4") *Email account credential login
          v-col(cols="5")
            v-text-field(
              v-model="users.email",
              label="Email",
              type="email",
              disabled
            )

        //- v-row(no-gutters)
        //-   v-col(cols="4") 
        //-     v-subheader Phone Number
        //-   v-col(cols="5")
        //-     v-text-field(
        //-       maxlength = "14"
        //-       v-model="users.msisdn",
        //-       label="Phone Number",
        //-       :rules="[rules.required, rules.msisdn]",
        //-       @keypress="isNumber($event)"
        //-     )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader Super Admin
          v-col(cols="5")
            v-radio-group(v-model="users.is_super_admin", row)
              v-radio(label="Yes", value="yes")
              v-radio(label="No", value="no")

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader Status
          v-col(cols="5")
            v-radio-group(v-model="users.is_active", row)
              v-radio(label="Active", value="active")
              v-radio(label="Non Active", value="nonactive")

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader Auto Notif Payment Request
          v-col(cols="5")
            v-radio-group(v-model="users.is_auto_notif_pr", row)
              v-radio(label="Yes", value="yes")
              v-radio(label="No", value="no")

        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="$router.push('/users')") Back
          v-btn.custom__padding-btn(
            color="blue-secondary",
            :disabled="!formIsValid",
            @click="update()"
          ) Update

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  data: () => ({
    users: {
      full_name: "",
      email: "",
      msisdn: "",
      is_super_admin: "",
      is_active: "",
      is_auto_notif_pr: "",
    },
    rules: {
      required: (value) => !!value || "This field is required.",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email format";
      },
      msisdn: (value) =>
        (value && value.length >= 10) || "Mobile number cannot be less than 10",
    },
    overlay: false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid() {
      return (
        this.users.full_name &&
        this.users.email &&
        //- this.users.msisdn.length >= 10 &&
        this.users.is_super_admin &&
        this.users.is_active &&
        this.users.is_auto_notif_pr
      );
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/users/${this.$route.params.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.overlay = false;
          this.users.full_name = res.data.data.full_name;
          this.users.email = res.data.data.email;
          this.users.msisdn = res.data.data.msisdn;
          this.users.is_super_admin =
            res.data.data.is_super_admin == true ? "yes" : "no";
          this.users.is_active =
            res.data.data.is_active == true ? "active" : "nonactive";
          this.users.is_auto_notif_pr =
            res.data.data.is_auto_notif_pr == true ? "yes" : "no";
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err, { icon: "error" });
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    },
    update() {
      this.overlay = true;
      this.users.is_super_admin =
        this.users.is_super_admin == "no" ? false : true;
      this.users.is_active = this.users.is_active == "active" ? true : false;
      this.users.is_auto_notif_pr = this.users.is_auto_notif_pr == "yes" ? true : false;

      this.$store
        .dispatch("updateDataUsers", {
          users: this.users,
          user_id: `${this.$route.params.id}`,
        })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          if (res.data.status == 200) {
            this.$toasted.success("Success Update Data", {
              icon: "check_circle",
            });
            return this.$router.push("/users");
          } else {
            this.$toasted.error("Failed to Update Data", { icon: "error" });
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.error, { icon: "error" });
        });
    },
    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9 ]+$/.test(char)) return true;
      else e.preventDefault();
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}
</style>